import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingComponent, TableDataPickerDialogComponent, TreeDataPickerDialogComponent } from './components';
import { CustomSelectorComponent } from './components/custom-selector';
import { InfoPanelTriggerComponent } from './components/info-panel/info-panel-trigger/info-panel-trigger.component';
import { InfoPanelComponent } from './components/info-panel/info-panel.component';
import { InfoTooltipComponent } from './components/info-tooltip/info-tooltip.component';
import { TextLimiterComponent } from './components/text-limiter/text-limiter.component';
import { MaterialModule } from './material.module';
import { LocalIsoPipe } from './pipes/local-iso.pipe';
import { StrToLocalDatePipe } from './pipes/str-to-local-date.pipe';
import { ReleaseNoteFormatPipe } from './pipes/release-note-format.pipe';
import { AnnouncementComponent } from '@app/modules/announcements/announcement.component';
import { NoticeBannerComponent } from '@app/shared/components/notice-banner/notice-banner.component';
import { GenericDialogComponent } from './components/generic-dialog/generic-dialog.component';
import { ManagementListComponent } from './components/management-list/management-list.component';

const COMPONENTS = [
  LoadingComponent, 
  GenericDialogComponent,
  TableDataPickerDialogComponent, 
  TreeDataPickerDialogComponent, 
  CustomSelectorComponent, 
  InfoTooltipComponent, 
  TextLimiterComponent, 
  InfoPanelComponent, 
  InfoPanelTriggerComponent, 
  AnnouncementComponent,
  NoticeBannerComponent,
  ManagementListComponent
]
const PIPES = [LocalIsoPipe, StrToLocalDatePipe, ReleaseNoteFormatPipe]
@NgModule({
  declarations: [COMPONENTS, PIPES],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [COMPONENTS, PIPES, FormsModule, MaterialModule, ReactiveFormsModule],
  providers: [PIPES]
})
export class SharedModule { }
